import React from 'react';
import { appImages, appLinkStyle, onEmailClick } from '@utils/globalConstant';
import { Logo, CMSLink, Ta11yImage } from '@core/index';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { useA11y } from '@context/Utils/A11y';
import './Footer.scss';
import Icons from '@core/Utils/Icons/Icons';
import useCmsImage from '@utils/useCmsImage';

// TODO remove all hardcoded text and add cms keys

export function FooterInfo({ infoText }) {
  const { tA11yTranslate } = useA11y();

  return (
    <div className="bg-ek-midblue py-16">
      <AppPageContentWrapper isDefaultPadding={false}>
        <div className="row">
          <div className="col-sm-7 col-lg-9">
            {tA11yTranslate(infoText).isHtml ? (
              <p
                className="ek-copy-sm-14-medium text-primary mb-16 mb-sm-0"
                dangerouslySetInnerHTML={{ __html: tA11yTranslate(infoText).content }}
              />
            ) : (
              <p className="ek-copy-sm-14-medium text-primary mb-16 mb-sm-0">
                {tA11yTranslate(infoText).content}
              </p>
            )}
          </div>
          <div className="col-sm-5 col-lg-3 d-flex align-items-center justify-content-center justify-content-lg-start">
            <ul className="list-unstyled d-flex gap-12 m-0">
              <li>
                <a
                  className="d-inline-block"
                  href={tA11yTranslate('ek_ftr_app_store_lnk1')?.url} // TODO: add href
                  target="_blank"
                  rel="noreferrer">
                  <img
                    style={{ width: '88.419px', height: '29.556px' }}
                    src={appImages.iosStore}
                    alt={tA11yTranslate('ek_ftr_app_store_lnk1').ariaLabel} // TODO: Add alt text
                  />
                </a>
              </li>
              <li>
                <a
                  className="d-inline-block"
                  href={tA11yTranslate('ek_ftr_play_store_lnk1')?.url} // TODO: add href
                  target="_blank"
                  rel="noreferrer">
                  <img
                    style={{ width: '99.254px', height: '29.556px' }}
                    src={appImages.androidStore}
                    alt={tA11yTranslate('ek_ftr_play_store_lnk1').ariaLabel} // TODO: Add alt text
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </AppPageContentWrapper>
    </div>
  );
}

export function FooterLinks() {
  return (
    <ul className="list-unstyled m-0 gap-24 d-flex flex-row flex-wrap">
      <li>
        <CMSLink linkKey="ek_ftr_lnk1" linkStyle={`${appLinkStyle.WHITE}`} />
      </li>
      <li>
        <CMSLink linkKey="ek_ftr_lnk2" linkStyle={`${appLinkStyle.WHITE}`} />
      </li>
      <li>
        <CMSLink linkKey="ek_ftr_lnk3" linkStyle={`${appLinkStyle.WHITE}`} />
      </li>
      <li>
        <CMSLink linkKey="ek_ftr_lnk4" linkStyle={`${appLinkStyle.WHITE}`} />
      </li>
      <li>
        <CMSLink linkKey="ek_ftr_lnk5" linkStyle={`${appLinkStyle.WHITE}`} />
      </li>
    </ul>
  );
}

export function Footer() {
  const { tA11yTranslate } = useA11y();
  const serviceEmailButtonContent = tA11yTranslate('ek_account_service_contact_btn2');
  const email1Content = tA11yTranslate('ek_ftr_txt7').content;

  const image1 = useCmsImage('ek_reg_legi_badges_chip');
  const image2 = useCmsImage('ek_reg_legi_badges_connect');
  const image3 = useCmsImage('ek_reg_legi_badges_bild');

  return (
    <footer>
      <FooterInfo infoText="ek_ftr_txt1" />

      <div className="bg-ek-gradient py-32">
        <AppPageContentWrapper isDefaultPadding={false}>
          <div className="row pb-40">
            <div className="col-12 col-lg-auto px-0 me-md-80 d-flexs">
              <div>
                <div className="pb-40">
                  {/* <NavigationLink to="/"> */}
                    <Logo variant="light" height='82px' />
                  {/* </NavigationLink> */}
                </div>
                <div className="pb-80 pb-lg-0 pb-xl-0 text-ek-white">
                  {tA11yTranslate('ek_ftr_hdl1').isHtml ? (
                    <p
                      className="pb-16 ek-h3"
                      dangerouslySetInnerHTML={{ __html: tA11yTranslate('ek_ftr_hdl1').content }}
                    />
                  ) : (
                    <p className="pb-16 ek-h3">{tA11yTranslate('ek_ftr_hdl1').content}</p>
                  )}
                  <p className="pb-8 d-flex align-items-center">
                      <Icons name='PHONE_CALL' alt={tA11yTranslate('ek_logo_phone_alt').content} className="icon-white me-8" colorType='dark'/>
                    {' '}
                    <a
                      href={tA11yTranslate('ek_ftr_txt2')?.url}
                      className="text-ek-white ek-copy-sm-14-medium-underlined">
                      {tA11yTranslate('ek_ftr_txt2').isHtml ? (
                        <div dangerouslySetInnerHTML={{ __html: tA11yTranslate('ek_ftr_txt2').content }} />
                      ) : (
                        tA11yTranslate('ek_ftr_txt2').content
                      )}
                    </a>
                  </p>
                  <p className="pb-8 d-flex align-items-center">
                      <Icons name='MAIL' className="icon-white me-10" alt={tA11yTranslate('ek_logo_email_alt').content} height={16} colorType='dark' />
                    {' '}
                    <span
                      tabIndex={0}
                      role='link'
                      onClick={() => onEmailClick(serviceEmailButtonContent.url)}
                      className="text-ek-white ek-copy-sm-14-medium-underlined cursor-pointer">
                      {email1Content}
                    </span>
                  </p>
                  <div className="ek-input-feedback-text">
                    {tA11yTranslate('ek_ftr_txt3').isHtml ? (
                      <p
                        className="pb-4"
                        dangerouslySetInnerHTML={{ __html: tA11yTranslate('ek_ftr_txt3').content }}
                      />
                    ) : (
                      <p className="pb-4">{tA11yTranslate('ek_ftr_txt3').content}</p>
                    )}
                    {tA11yTranslate('ek_ftr_txt4').isHtml ? (
                      <p
                        className="pb-24"
                        dangerouslySetInnerHTML={{ __html: tA11yTranslate('ek_ftr_txt4').content }}
                      />
                    ) : (
                      <p className="pb-24">{tA11yTranslate('ek_ftr_txt4').content}</p>
                    )}
                  </div>
                  <p className="pb-8 d-flex align-items-center">
                    <Icons name='SMARTPHONE' alt={tA11yTranslate('ek_logo_ mobile_alt').content} className="icon-white me-10" colorType='dark' />
                    {' '}
                    <a
                      href={tA11yTranslate('ek_ftr_txt5')?.url}
                      className="text-ek-white ek-copy-sm-14-medium-underlined">
                      {tA11yTranslate('ek_ftr_txt5').isHtml ? (
                        <div dangerouslySetInnerHTML={{ __html: tA11yTranslate('ek_ftr_txt5').content }} />
                      ) : (
                        tA11yTranslate('ek_ftr_txt5').content
                      )}
                    </a>
                  </p>
                  {tA11yTranslate('ek_ftr_txt6').isHtml ? (
                    <p
                      className="ek-input-feedback-text"
                      dangerouslySetInnerHTML={{ __html: tA11yTranslate('ek_ftr_txt6').content }}
                    />
                  ) : (
                    <p className="ek-input-feedback-text">{tA11yTranslate('ek_ftr_txt6').content}</p>
                  )}
                </div>
              </div>
            </div>

            <div className="col-12 col-sm px-md-0 flex-grow-1 d-flex align-items-end">
              <div className="footer-images">
                {image1 ? <Ta11yImage
                  imageContent={image1}
                  className='footer-image footer-image--first'
                /> : ''}
                {image2 ? <Ta11yImage
                  imageContent={image2}
                  className='footer-image footer-image--second'
                /> : ''}
                {image3 ? <Ta11yImage
                  imageContent={image3}
                  className='footer-image footer-image--third'
                /> : ''}
              </div>
            </div>
          </div>

          <FooterLinks />
        </AppPageContentWrapper>
      </div>
    </footer>
  );
}

export default Footer;
